module.exports = __webpack_public_path__ + "img/map.c54fa9cd.png";